import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { connect, ConnectedProps } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import { State } from 'safe'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { signIn } from '../../redux/actions/authentication'
import { isNevulaDisabled } from '../../utils/utils'
import LogoNevula from '../../assets/images/logo-nevula.svg'

import LoginPerson from '../../assets/images/login-banner.jpg'
import {
  IoCart,
  IoCashOutline,
  IoPeopleCircle,
  IoPersonCircle,
} from 'react-icons/io5'

const server = process.env.REACT_APP_SERVER_URL

const Login: React.FC<PropsFromRedux> = ({ signIn, auth }, props) => {
  const form = useForm<{
    email: string
    password: string
  }>()
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const { addAlert } = useSnackBars()

  const [nevulaAdvice, setNevulaAdvice] = useState<boolean | null>(null)

  let objTransform = {
    401: 'Credenciales incorrectas',
  }

  const location = useLocation()

  const [windowSize, setWindowSize] = useState(getWindowSize())


  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  useEffect(() => {
    // console.log("local", JSON.parse(localStorage.getItem("credentials") || "") )
    let accesToken = JSON.parse(localStorage.getItem('credentials') || '{}')
      ?.access_token
    if (accesToken) {
      history.push('/dashboard')
      return
    }
    let instance = new URLSearchParams(location.search)
    // console.log("props", new URLSearchParams(location.search).get("luis"))

    if (instance.get('confirmed')) {
      addAlert({
        message: 'Correo verificado satisfactoriamente',
        status: 'success',
      })
    }

    if (instance.get('passwordChanged')) {
      addAlert({
        message: 'Contraseña cambiada satisfactoriamente',
        status: 'success',
      })
    }

    if (Boolean(localStorage.getItem('nevulaAdvice'))) {
      // addAlert({ message: "Todos los primeros de cada mes, de 12:00 a 12:20 am, Nevula entra en mantenimiento. Por favor espera unos minutos e intenta de nuevo", status: 'success' })
      setNevulaAdvice(true)
    }

    //eslint-disable-next-line
  }, [])

  // useEffect(() => {
  //   console.log("GET VALOR", Boolean(localStorage.getItem('nevulaAdvice')))

  //   setNevulaAdvice()
  // }, [])

  const onLogin = async (values) => {
    if (isNevulaDisabled()) {
      setNevulaAdvice(true)
      return
    }

    // if (windowSize.innerWidth < 1024) {
    //   addAlert({
    //     message:
    //       'No puedes usar Nevula con una resolución de pantalla menor a 1024x768. Por favor ajusta la configuración de tu pantalla y vuelve a intentarlo',
    //     status: 'warning',
    //   })
    //   return
    // }

    setLoading(true)
    try {
      const result: any = await signIn(values)
      localStorage.removeItem('nevulaAdvice')

      if (result?.access_token) {

        if (windowSize.innerWidth < 1024) {
          history.push('/stats')
        } else {
          history.push('/dashboard')
        }
      }

      //   if (result.challenge?.challengeName === 'NEW_PASSWORD_REQUIRED') {
      //     addAlert({ message: result.message, status: 'warning' })
      //     history.push(
      //       `/nuevaClave?username=${result.userData?.username}&tenantCode=${result.userData?.tenantID}&session=${result.challenge?.session}`
      //     )
      //   } else if (result.authentication?.AccessToken) {
      //     addAlert({ message: result.message, status: 'success' })
      //     history.push('/dashboard/home/home')
      //   }
      // } catch (err) {
      //   addAlert({
      //     message: 'Ha ocurrido un error al intentar ingresar a nevula.',
      //     status: 'error',
      //   })
      // } finally {
      //   setLoading(false)
      // }
    } catch (err: any) {
      console.log('ERR', err)
      if (
        err.code === 'NotAuthorizedException' &&
        err.message === 'User is disabled.'
      ) {
        addAlert({
          message: 'Su usuario se encuentra actualmente deshabilitado.',
          status: 'error',
        })
        return
      }
      if (err.code === 'NotAuthorizedException') {
        addAlert({
          message: 'Usuario o Contraseña incorrecta',
          status: 'error',
        })
      }
      if (err.code === 'UserNotFoundException') {
        addAlert({
          message: 'Usuario no existente',
          status: 'error',
        })
      }
      if (err.code === 'UserNotConfirmedException') {
        addAlert({
          message: 'Usuario no confirmado',
          status: 'error',
        })
      }
      // if (axios.isAxiosError(err)) {
      //   addAlert({
      //     message: objTransform[err.response?.data.statusCode] || 'Error al iniciar sesión',
      //     status: 'error',
      //   })
      // }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="grid grid-cols-12 h-screen">
      <div
        className={`${
          windowSize.innerWidth > 1300 ? 'col-span-7' : 'col-span-12'
        } flex flex-col justify-center items-center`}
      >
        <img src={LogoNevula} alt="zerux" className="mb-5" />
        <div
          className={`shadow-md bg-white dark:bg-black rounded-2xl px-10 py-12 mb-4 ${
            windowSize.innerWidth < 700
              ? 'w-11/12'
              : windowSize.innerWidth < 1300
              ? 'w-1/3'
              : 'w-2/4'
          }`}
        >
          <div className="w-full break-words">
            <Form form={form} onSubmit={onLogin}>
              {/* <FormItem
          classes="col-span-12 my-2 mx-0"
          name="tenantCode"
          rules={{ required: 'Ingrese su usuario' }}
        >
          <InputText label="ID de empresa" />
        </FormItem> */}
              <FormItem
                classes="col-span-12 my-2"
                name="email"
                rules={{ required: 'Ingrese su usuario' }}
              >
                <InputText
                  label="Usuario"
                  isUpperValue={false}
                />
              </FormItem>
              <FormItem
                name="password"
                classes="col-span-12 my-2"
                rules={{ required: 'Ingrese su contraseña' }}
              >
                <InputText
                  label="Contraseña"
                  password
                  isUpperValue={false}
                  />
              </FormItem>

              {/* <a className='col-span-12' href=''>Registrarse</a> */}

              {/* <Link to="/registro" className="col-span-12 hover:text-primary" onClick={() => {
          console.log("click...")
        }}>
          Registrarse
        </Link> */}
              <div className='col-span-12' >
              <a
                className="col-span-12 hover:text-primary cursor-pointer text-sm text-primary font-semibold"
                onClick={() => {
                  if (isNevulaDisabled()) {
                    setNevulaAdvice(true)
                    return
                  }
                  history.push('/registro')
                }}
              >
                Registrarse
              </a>
              </div>

              {windowSize.innerWidth < 1024 && (
                <div className="col-span-12 mt-5">
                  <label>
                    Zerux está disponible para dispositivos móviles solo a
                    través de la aplicación que puedes descargar desde la
                    AppStore o la PlayStore
                  </label>
                  <div
                    className={`flex justify-center mt-5`}
                    style={{
                      display: 'flex',
                      flexDirection:
                        windowSize.innerWidth < 400 ||
                        (windowSize.innerWidth > 700 &&
                          windowSize.innerWidth < 1300)
                          ? 'column'
                          : 'row',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      className={
                        windowSize.innerWidth < 400 ||
                        (windowSize.innerWidth > 700 &&
                          windowSize.innerWidth < 1300)
                          ? 'mr-0'
                          : 'mr-5'
                      }
                      height={45}
                      width={150}
                      src="https://es.logodownload.org/wp-content/uploads/2019/06/disponible-en-google-play-badge-1.png"
                    />
                    <img
                      height={45}
                      width={150}
                      src="https://cabildodelapalma.es/sites/default/files/2021-03/app_store.png"
                    />
                  </div>
                </div>
              )}

              <Button
                type="primary"
                classes="col-span-12 mt-2 font-semibold tracking-wide"
                htmlType="submit"
                loading={loading}
              >
                Iniciar sesion
              </Button>
            </Form>

            <div className="flex flex-col justify-center items-center mt-2">

            <a
                className="col-span-12 cursor-pointer mt-5"
                onClick={() => history.push('/verificarCorreo')}
                style={{color: "#03388f"}}
              >
                ¿Olvidaste tu contraseña?
              </a>
              
              <a className='mt-3 cursor-pointer' onClick={() => history.push('/deudor')} style={{color: '#03388f'}}>
              ¿Usuario inhabilitado?
              </a>
            </div>

            <ModalConfirm
              isInfo={true}
              displayConfirmModal={!!nevulaAdvice}
              title="Todos los primeros de cada mes, de 12:00 a 12:20 am, Zerux entra en mantenimiento. Por favor espera unos minutos e intenta de nuevo"
              onCancel={() => {
                localStorage.removeItem('nevulaAdvice')
                setNevulaAdvice(false)
              }}
              onConfirm={() => {
                localStorage.removeItem('nevulaAdvice')
                setNevulaAdvice(false)
              }}
              positive={true}
            />
          </div>
        </div>
      </div>

      {windowSize.innerWidth > 1300 && (
        <div
          className="col-span-5"
          style={{
            backgroundColor: '#006AEA',
            paddingTop: 20,
            paddingLeft: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {/* <div className="flex justify-between">
          <div style={{ width: 280 }}>
            <label style={{ fontSize: 25, fontWeight: 800, color: 'white' }}>
              La nueva Generación de Software Administrativo.
            </label>
          </div>
          <div className="w-52">
            <img src={LogoNevula} alt="nevula" />
          </div>
        </div>

        <div
          style={{
            height: 80,
            borderWidth: 1,
            width: '100%',
            borderColor: '#11FFFF',
            borderRadius: 10,
            marginTop: 40,
            paddingRight: 20,
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <div className="flex justify-between">
            <div>
              <h2
                className="text-white"
                style={{ fontWeight: 500, fontSize: 28 }}
              >
                Plan Estudiantil
              </h2>
              <div className="flex mt-1">
                <IoPersonCircle style={{ color: 'white' }} size={22} />
                <label className="text-white ml-2">{`(1 Usuario)`}</label>
              </div>
            </div>

            <div className="flex justify-center items-center">
              <IoCart
                size={30}
                color={'rgba(255, 255, 255, 0.5)'}
                className="mr-1.5"
              />
              <h1 style={{ color: '#1BF3A6' }}>¡Gratis!</h1>
            </div>
          </div>
        </div>

        <div
          style={{
            height: 80,
            borderWidth: 1,
            width: '100%',
            borderColor: '#11FFFF',
            borderRadius: 10,
            marginTop: 10,
            paddingRight: 20,
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <div className="flex justify-between">
            <div>
              <h2
                className="text-white"
                style={{ fontWeight: 500, fontSize: 28 }}
              >
                Plan Emprendedor
              </h2>
              <div className="flex mt-1">
                <IoPeopleCircle style={{ color: 'white' }} size={22} />
                <label className="text-white ml-2">{`(2 Usuarios)`}</label>
              </div>
            </div>

            <div className="flex justify-center items-center">
              <IoCashOutline
                size={30}
                color={'rgba(255, 255, 255, 0.5)'}
                className="mr-1.5"
              />
              <h1 style={{ color: 'white' }}>
                $12,<strong style={{ fontSize: 17 }}>00</strong>
              </h1>
            </div>
          </div>
        </div>

        <div
          style={{
            height: 80,
            borderWidth: 1,
            width: '100%',
            borderColor: '#11FFFF',
            borderRadius: 10,
            marginTop: 10,
            paddingRight: 20,
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <div className="flex justify-between">
            <div>
              <h2
                className="text-white"
                style={{ fontWeight: 500, fontSize: 28 }}
              >
                Plan PYME
              </h2>
              <div className="flex mt-1">
                <IoPeopleCircle style={{ color: 'white' }} size={22} />
                <label className="text-white ml-2">{`(5 Usuarios)`}</label>
              </div>
            </div>

            <div className="flex justify-center items-center">
              <IoCashOutline
                size={30}
                color={'rgba(255, 255, 255, 0.5)'}
                className="mr-1.5"
              />
              <h1 style={{ color: 'white' }}>
                $18,<strong style={{ fontSize: 17 }}>00</strong>
              </h1>
            </div>
          </div>
        </div>

        <div
          style={{
            height: 80,
            borderWidth: 1,
            width: '100%',
            borderColor: '#11FFFF',
            borderRadius: 10,
            marginTop: 10,
            paddingRight: 20,
            paddingLeft: 20,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <div className="flex justify-between">
            <div>
              <h2
                className="text-white"
                style={{ fontWeight: 500, fontSize: 28 }}
              >
                Plan Corporativo
              </h2>
              <div className="flex mt-1">
                <IoPeopleCircle style={{ color: 'white' }} size={22} />
                <label className="text-white ml-2">{`(10 Usuarios)`}</label>
              </div>
            </div>

            <div className="flex justify-center items-center">
              <IoCashOutline
                size={30}
                color={'rgba(255, 255, 255, 0.5)'}
                className="mr-1.5"
              />
              <h1 style={{ color: 'white' }}>
                $35,<strong style={{ fontSize: 17 }}>00</strong>
              </h1>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <img
            src={LoginPerson}
            alt="nevula"
            style={{ height: 140, width: 140 }}
          />
        </div> */}

          <div
            style={{
              backgroundImage: `url(${LoginPerson})`,
              backgroundSize: '100%',
              backgroundRepeat: 'no-repeat',
              height: '80%',
              width: '100%',
              cursor: 'pointer',
            }}
            onClick={() => {
              window.open('https://www.zerux.app/', '_blank')
            }}
          >
            {/* <img src={LoginPerson} style={{maxHeight: '100%', objectFit: 'contain'}} /> */}
          </div>
        </div>
      )}
    </div>
  )
}

const mapState = ({ auth }: State) => ({ auth })

const connector = connect(mapState, { signIn })

export default connector(Login)

type PropsFromRedux = ConnectedProps<typeof connector>
